<template>
  <div class="loading-cover">
    <div class="cover">
      <template v-if="isCat">
        <div class="cover__icon">
          <img src="@/assets/images/img-main-sam.png" alt="loading">
        </div>
        <div class="cover__text">{{ $t('viewer.page.loading.text') }}</div>
      </template>
      <LoadingBounce v-else />
    </div>
  </div>
</template>

<script>
export default {
  name: 'cat-loading-cover',

  props: {
    isCat: {
      default: true,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
  .loading-cover {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 200;

    .cover {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      bottom: 0;
      margin-top: -80px;
      height: 160px;

      .cover__icon {
        text-align: center;
        padding-bottom: 24px;
      }

      .cover__text {
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
      }
    }

  }
</style>
